export const DEFAULT_API_BASE_URL = 'https://api.search.reho24.ru/api/v1';
export const DEFAULT_BOOKING_BASE_URL = 'https://search.reho24.ru';

export const DEFAULT_PAGE_SIZE = 12;
export const DEFAULT_PAGINATION = 'pages';
export const DEFAULT_BOOKING_FLOW = 'modal';
export const DEFAULT_MODE = 'client_only';

export const WIDGET_VERSION = '1.1.0';
